import { environment } from './../environments/environment';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { AlertService } from './service/alert.service';
import { Component } from '@angular/core';
import { AlertaTempoSessaoService } from './service/alerta-tempo-sessao.service';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'premocenter-angular';
  sessaoExpirada = false
  premocenter = environment.baseUrlPremocenter
  loadingDataImg: boolean = false;
  constructor(
    private alertaSessao: AlertaTempoSessaoService,
    private alertService: AlertService
  ){
    this.alertaSessao.alertaFimSessao().subscribe((resp:any) =>{
      if(resp){
        this.sessaoExpirada = resp
        this.confirmAlert()
      } else {
        this.sessaoExpirada = false
      }
    })
  }

  public confirmAlert(): void {
    Swal.fire({
      title: 'Deseja renovar sua sessão?',
      text: `Expira as: ${localStorage.getItem('expira_token')}`,
      showCancelButton: true,
      confirmButtonColor: '#00AA5B',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar'
    }).then((result:any) => {
      if (result.isConfirmed) {
        var token = localStorage.getItem('token')
        this.alertaSessao.renovarToken(token).subscribe((resp:any) => {
          if(resp){
            localStorage.setItem('token', resp.access_token)
            Swal.fire({
              icon: 'success',
              title: 'Sessão Renovada!',
              showConfirmButton: false,
              timer: 1500
            })
          }
        },
        erro => {
          Swal.fire({
            icon: 'warning',
            title: 'Ocorreu um erro, você será redirecionado para o PremoCenter!',
            showConfirmButton: false,
            timer: 2000
          })
          setTimeout(() => {
            window.location.href = `${this.premocenter}`
          }, 3000)
        }
        )

      }
    })
  }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  getTitle(state: any, parent: any): any {
    var data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(... this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  navigationInterceptor(event: any): void {

    if (event instanceof NavigationStart) {
      this.loadingDataImg = true;
    }
    if (event instanceof NavigationEnd) {
      this.loadingDataImg = false;
    }

    if (event instanceof NavigationCancel) {
      this.loadingDataImg = false;
    }
    if (event instanceof NavigationError) {
      this.loadingDataImg = false;
    }
  }

}
